import script from "./HrSegmentedBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./HrSegmentedBtn.vue?vue&type=script&setup=true&lang=js"

import "./HrSegmentedBtn.vue?vue&type=style&index=0&id=0f289744&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f289744"]])

export default __exports__
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnToggle});
